import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ReactiveFormsModule } from '@angular/forms';
import { SettingsService } from '../../../../../core/services/settings.service';
@Component({
  selector: 'app-change-pin',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './change-pin.component.html',
  styleUrl: './change-pin.component.css'
})

export class ChangePinComponent implements OnInit {
  @ViewChild('successModal') successModalTemplate: any;
  successMessage: string = '';

  pinForm: FormGroup;
  showPinUI = false;
  currentPinType: 'CURRENT' | 'NEW' | 'CONFIRM' = 'CURRENT';
  error = '';
  responseError='';
  currentPinChanged = false;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private settingsService: SettingsService,
    private modalService: NgbModal
  ) {
    this.pinForm = this.fb.group({
      currentPin: ['', [Validators.required, Validators.pattern('^[0-9]{4}$')]],
      newPin: ['', [Validators.required, Validators.pattern('^[0-9]{4}$')]],
      confirmPin: ['', [Validators.required, Validators.pattern('^[0-9]{4}$')]]
    });
  }

  ngOnInit(): void {
    this.pinForm.get('currentPin')?.valueChanges.subscribe(() => {
      if (this.responseError) {
        this.responseError = '';
        this.currentPinChanged = true;
      }
    });
  }

  openPinUI(type: 'CURRENT' | 'NEW' | 'CONFIRM'): void {
    this.currentPinType = type;
    this.showPinUI = true;
  }

  closePinUI(): void {
    this.showPinUI = false;
  }

  onKeyPressed(key: string): void {
    const control = this.getCurrentPinControl();
    if (!control) return;

    let currentValue = control.value || '';

    if (key === '<') {
      currentValue = currentValue.slice(0, -1);
    } else if (currentValue.length < 4) {
      currentValue += key;
    }

    control.setValue(currentValue);
  }

  getCurrentPinControl() {
    switch (this.currentPinType) {
      case 'CURRENT':
        return this.pinForm.get('currentPin');
      case 'NEW':
        return this.pinForm.get('newPin');
      case 'CONFIRM':
        return this.pinForm.get('confirmPin');
      default:
        return null;
    }
  }

  showError(): boolean {
    if (this.pinForm.get('newPin')?.value !== this.pinForm.get('confirmPin')?.value) {
      this.error = 'New PIN and Confirm PIN do not match';
      return true;
    }
    if (this.pinForm.get('currentPin')?.value === this.pinForm.get('newPin')?.value) {
      this.error = 'New PIN cannot be the same as current PIN';
      return true;
    }
    this.error = '';
    return false;
  }

  save(): void {
    if (this.pinForm.invalid || this.showError()) {
      return;
    }

    const { currentPin, newPin } = this.pinForm.value;

    this.settingsService.changePin(currentPin, newPin).subscribe({
      next: (response) => {
        if (response.changed) {
          this.successMessage = 'PIN changed successfully';
          this.modalService.open(this.successModalTemplate, { centered: true });
          this.activeModal.close();
        }
      },
      error: (err) => {
        this.responseError = err.error?.error?.message || 'Failed to change PIN';
      }
    });
  }

  close(): void {
    this.activeModal.dismiss();
  }
}